import type { GA4PageNameType } from '@/ga4types'
import analytics from '@/shared-utils/analytics'
import type { ProductType } from '@/types'

export type LogSearchFormAnalyticsParams = {
  cguid: string
  pageName: GA4PageNameType
  productType: ProductType | 'multi-hotel'
  isMobile: boolean
}

export default function logSearchFormAnalytics({
  cguid,
  pageName,
  productType,
  isMobile,
}: LogSearchFormAnalyticsParams) {
  analytics.log({
    message: 'User submitted search form',
    cguid,
    searchForm: productType,
    pageName,
    isMobile,
  })
}
